import React from "react";
import { T } from "../theme";

// Session state pill, shared by the session block and the ledger's coaching
// rows. `label` overrides the default wording (e.g. "Didn't happen · rolled
// over +$400") while keeping the status colouring.
export default function SessionPill({ status, label }) {
  const styles = {
    done:      { label: "Delivered",              bg: T.root,          color: T.fgOnDark,   border: T.root },
    cancelled: { label: "Cancelled, not counted", bg: "transparent",   color: T.fgMuted,    border: T.borderStrong },
    missed:    { label: "Didn't happen",          bg: "transparent",   color: T.statusOff,  border: T.statusOff },
    scheduled: { label: "Not confirmed",          bg: T.statusRiskBg,  color: T.statusRisk, border: "transparent" },
  }[status] || {};
  return (
    <span style={{ fontSize: 10, fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", padding: "3px 8px", borderRadius: T.radiusPill, background: styles.bg, color: styles.color, border: `1px solid ${styles.border}`, whiteSpace: "nowrap" }}>{label || styles.label}</span>
  );
}
